/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
import {Suspense} from 'react';
import Loader from 'components/loader';
import {Main} from 'components/layout';

// eslint-disable-next-line
const SuspenseComponent = (ComposedComponent, WaitingComponent = undefined): any => (props): any => { // Todo change any
  if (typeof WaitingComponent === 'undefined') {
    WaitingComponent = <Main><Loader /></Main>;
  }

  return <Suspense fallback={WaitingComponent} >
    <ComposedComponent {...props} />
  </Suspense>;
};

export default SuspenseComponent;